(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var om = document.querySelector('[data-om]');
  if (!om) return;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var calm = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var form = $('[data-om-form]', om);
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  var track = $('[data-om-track]', om), slides = $$('[data-om-slide]', om), dots = $$('[data-om-dot]', om), thumbs = $$('[data-om-thumb]', om);
  var count = $('[data-om-count]', om), cur = -1;
  var mark = function (i) {
    if (i === cur) return;
    cur = i;
    dots.concat(thumbs).forEach(function (b) { b.setAttribute('aria-current', parseInt(b.getAttribute('data-i'), 10) === i ? 'true' : 'false'); });
    if (count) count.textContent = (i + 1) + ' / ' + slides.length;
  };
  var go = function (i) {
    if (!track || !slides.length) return;
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[i].offsetLeft, behavior: calm ? 'auto' : 'smooth' });
    mark(i);
  };
  if (track && slides.length) {
    var sf = 0;
    track.addEventListener('scroll', function () {
      if (sf) return;
      sf = window.requestAnimationFrame(function () {
        sf = 0;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i >= 0 && i < slides.length) mark(i);
      });
    }, { passive: true });
    dots.concat(thumbs).forEach(function (b) { b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-i'), 10)); }); });
    $$('[data-om-step]', om).forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-om-step'), 10)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    mark(0);
  }

  var setVariant = function (r) {
    var id = r.value, d = r.dataset;
    $$('[data-om-price]').forEach(function (el) { el.textContent = d.price; });
    $$('[data-om-add-p]').forEach(function (el) { el.textContent = d.price; });
    $$('[data-om-wp]').forEach(function (el) { el.textContent = d.wp; });
    $$('[data-om-vname]').forEach(function (el) { el.textContent = d.label; });
    var pp = $('[data-om-pp]'); if (pp) { pp.textContent = d.pp || ''; pp.hidden = !d.pp; }
    var un = $('[data-om-unit]'); if (un) un.textContent = d.unit || '';
    $$('[data-om-for]').forEach(function (el) { el.hidden = el.getAttribute('data-om-for') !== id; });
    $$('[data-om-col]').forEach(function (el) {
      var on = el.getAttribute('data-om-col') === id;
      el.classList.toggle('on', on);
      if (el.hasAttribute('aria-pressed')) el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var ss = $('[data-om-sticky-sub]'); if (ss) ss.textContent = d.label + ' · ' + d.price;
    var ask = d.ask === '1';
    var tog = function (sel, hide) { $$(sel).forEach(function (el) { el.hidden = hide; }); };
    tog('[data-om-buyrow]', ask); tog('[data-om-pay]', ask); tog('[data-om-tax]', ask); tog('[data-om-tix]', ask); tog('[data-om-sticky-add]', ask);
    tog('[data-om-askrow]', !ask); tog('[data-om-asknote]', !ask); tog('[data-om-sticky-ask]', !ask);
    var ab = $('[data-om-add]');
    if (ab) { ab.disabled = ask || d.avail === '0'; var at = $('[data-om-add-t]', ab); if (at) at.textContent = d.avail === '0' ? 'Ausverkauft' : 'In den Warenkorb'; }
    try { var u = new URL(window.location.href); u.searchParams.set('variant', id); window.history.replaceState(window.history.state, '', u); } catch (e) {}
  };
  if (form) {
    form.addEventListener('change', function (e) { if (e.target.name === 'id') setVariant(e.target); });
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-om-qty]');
      if (!b) return;
      var q = $('[data-om-q]', form), v = $('[data-om-qv]', form);
      var n = Math.max(1, Math.min(20, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-om-qty'), 10)));
      q.value = n; if (v) v.textContent = n;
    });
  }
  $$('[data-om-pick]').forEach(function (b) {
    b.addEventListener('click', function () {
      var r = form && form.querySelector('input[name="id"][value="' + b.getAttribute('data-om-pick') + '"]');
      if (!r || r.disabled) return;
      r.checked = true; setVariant(r);
      var t = document.getElementById('d-size');
      if (t && b.hasAttribute('data-om-jump')) t.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
    });
  });

  var WD = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  var MO = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];
  var SPAN = { AT: [1, 2], DE: [2, 3] }, NAME = { AT: 'Österreich', DE: 'Deutschland' }, CUT = 15 * 60;
  var country = om.getAttribute('data-c') === 'DE' ? 'DE' : 'AT';
  var sc = store.get('om-c'); if (sc === 'AT' || sc === 'DE') country = sc;
  var nowVienna = function () {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var g = function (t) { var x = parts.filter(function (p) { return p.type === t; })[0]; return x ? parseInt(x.value, 10) : 0; };
      return { d: new Date(Date.UTC(g('year'), g('month') - 1, g('day'))), min: (g('hour') % 24) * 60 + g('minute') };
    } catch (e) {
      var n = new Date();
      return { d: new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())), min: n.getHours() * 60 + n.getMinutes() };
    }
  };
  var work = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6; };
  var addWork = function (d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (work(x)) n--; } return x; };
  var dm = function (d) { return d.getUTCDate() + '. ' + MO[d.getUTCMonth()]; };
  var wdm = function (d) { return WD[d.getUTCDay()] + ', ' + dm(d); };
  var range = function (a, b) { return a.getUTCMonth() === b.getUTCMonth() ? a.getUTCDate() + '.–' + dm(b) : dm(a) + ' – ' + dm(b); };
  var left = function (m) { var h = Math.floor(m / 60), mm = m % 60; return (h ? h + ' Std. ' : '') + mm + ' Min.'; };
  var renderDelivery = function () {
    var n = nowVienna(), today = work(n.d) && n.min < CUT;
    var ship = today ? n.d : addWork(n.d, 1);
    var s = SPAN[country], a = addWork(ship, s[0]), b = addWork(ship, s[1]);
    var h = $('[data-om-cd-h]'), sub = $('[data-om-cd-s]');
    if (h) h.innerHTML = today ? 'Bestell in <strong>' + left(CUT - n.min) + '</strong>, dann geht dein Paket heute noch raus.' : 'Jetzt bestellen, Versand am <strong>' + wdm(ship) + '</strong>.';
    if (sub) sub.textContent = 'Lieferzeit nach ' + NAME[country] + ': ' + s[0] + '–' + s[1] + ' Werktage';
    var cd = $('[data-om-cd]'); if (cd) cd.classList.toggle('is-today', today);
    var t1 = $('[data-om-t1]'), t2 = $('[data-om-t2]'), t3 = $('[data-om-t3]');
    if (t1) t1.textContent = 'Heute';
    if (t2) t2.textContent = today ? 'Heute' : wdm(ship);
    if (t3) t3.textContent = range(a, b);
    $$('[data-om-c]').forEach(function (bt) { bt.setAttribute('aria-selected', bt.getAttribute('data-om-c') === country ? 'true' : 'false'); });
  };
  $$('[data-om-c]').forEach(function (bt) {
    bt.addEventListener('click', function () { country = bt.getAttribute('data-om-c'); store.set('om-c', country); renderDelivery(); });
  });
  renderDelivery();
  window.setInterval(renderDelivery, 30000);

  // "Weiterlesen" under the description
  $$('[data-om-desc-tg]').forEach(function (b) {
    var more = document.getElementById(b.getAttribute('aria-controls')), l = $('[data-om-desc-l]', b);
    if (!more) return;
    b.addEventListener('click', function () {
      var open = b.getAttribute('aria-expanded') !== 'true';
      more.hidden = !open;
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (l) l.textContent = open ? 'Weniger anzeigen' : 'Weiterlesen';
    });
  });

  var counts = function (c) { $$('[data-cart-count]').forEach(function (n) { n.textContent = c.item_count; n.hidden = c.item_count === 0; }); };
  var sheet = $('[data-om-sheet]');
  var openSheet = function () {
    if (!sheet) { window.location.href = root + 'cart'; return; }
    sheet.hidden = false;
    var f = $('[data-om-sheet-focus]', sheet); if (f) f.focus();
  };
  var closeSheet = function () { if (sheet) sheet.hidden = true; };
  var addItems = function (body, btn) {
    var lbl = btn && $('[data-om-add-t]', btn), old = lbl ? lbl.textContent : '';
    if (btn) { btn.disabled = true; if (lbl) lbl.textContent = 'Wird hinzugefügt …'; }
    var opts = body instanceof FormData
      ? { method: 'POST', headers: { Accept: 'application/json' }, body: body }
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) };
    return fetch(root + 'cart/add.js', opts)
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (c) { counts(c); openSheet(); })
      .catch(function (err) { window.alert((err && (err.description || err.message)) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.'); })
      .then(function () { if (btn) { btn.disabled = false; if (lbl) lbl.textContent = old; } });
  };
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var sel = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
    if (sel && sel.dataset.ask === '1') { var a = $('[data-om-askrow] a'); if (a) window.location.href = a.href; return; }
    addItems(new FormData(form), $('[data-om-add]', form));
  });
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-om-quick]');
    if (q) { addItems({ items: [{ id: parseInt(q.getAttribute('data-om-quick'), 10), quantity: 1 }] }, null); return; }
    if (e.target.closest('[data-om-close]')) closeSheet();
    if (e.target.closest('[data-om-sticky-add]') && form) {
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

  // Watch the whole CTA block: a hidden add button has an empty rect and would keep the bar up.
  var sticky = $('[data-om-sticky]'), add = form && $('[data-om-cta]', form);
  if (sticky && add && 'IntersectionObserver' in window) {
    // Shown whenever the buy block is off screen, above or below, so phones always have a CTA in reach.
    new IntersectionObserver(function (en) { sticky.hidden = en[0].isIntersecting; }).observe(add);
  }

  var openD = function (d) { if (!d || d.open) return; if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', ''); };
  var closeD = function (d) { if (!d) return; if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); };
  $$('dialog.om-dlg').forEach(function (d) {
    d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-om-dclose]')) closeD(d); });
  });
  $$('[data-om-open]').forEach(function (b) {
    b.addEventListener('click', function () { openD(document.getElementById(b.getAttribute('data-om-open'))); });
  });

  var code = om.getAttribute('data-code');
  var markActive = function () { om.classList.add('om-wel-on'); };
  if (store.get('om-wel') === '1') markActive();
  var applyCode = function () {
    if (!code) return;
    fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials: 'same-origin' })
      .then(function () { store.set('om-wel', '1'); markActive(); $$('[data-om-applied]').forEach(function (el) { el.hidden = false; }); })
      .catch(function () {});
  };
  $$('[data-om-copy]').forEach(function (cp) {
    cp.addEventListener('click', function () {
      var box = cp.closest('[data-om-codebox]'), note = box && box.parentNode && $('[data-om-copied]', box.parentNode);
      var ok = function () { cp.textContent = 'Kopiert'; if (note) note.textContent = 'Code in die Zwischenablage kopiert.'; window.setTimeout(function () { cp.textContent = 'Kopieren'; }, 2200); };
      var fail = function () { if (note) note.textContent = 'Bitte markiere den Code und kopiere ihn.'; };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(cp.getAttribute('data-om-copy')).then(ok, fail); else fail();
    });
  });
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    applyCode();
    var wd = document.getElementById('om-welcome');
    if (wd && window.location.hash !== '#om-klub-form') openD(wd);
  }

  // Horizontal rails (occasions, more flavours): previous/next buttons from tablet width up.
  $$('[data-om-rail]').forEach(function (b) {
    var sec = b.closest('section'), list = sec && $('[data-om-rail-list]', sec);
    if (!list) return;
    var upd = function () {
      var max = list.scrollWidth - list.clientWidth - 2;
      $$('[data-om-rail]', sec).forEach(function (x) { x.disabled = x.getAttribute('data-om-rail') === '-1' ? list.scrollLeft <= 2 : list.scrollLeft >= max; });
    };
    b.addEventListener('click', function () {
      list.scrollBy({ left: parseInt(b.getAttribute('data-om-rail'), 10) * list.clientWidth * 0.8, behavior: calm ? 'auto' : 'smooth' });
    });
    if (!list.hasAttribute('data-om-rail-on')) {
      list.setAttribute('data-om-rail-on', '');
      list.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
    }
    upd();
  });
})();
